export default (state = {
    selectedCategory: [],
    categories: [],
    products: [],
    breadcrumb: [],
    fetchingCategoriesList: false,
    fetchingProducts: false,
    fetched: false,
    has_more: true,
    is_loading: true,
    pagination: {
        count: 0,
        scroll_id: '',
    }

}, action) => {
    switch (action.type) {
        case 'FETCHING_CATEGORIES_LIST' :
            return {
                ...state,
                keyword: "",
                fetchingCategoriesList: true,
                fetched: false,
            };
         case 'UPDATE_CATEGORIES_LIST_BREADCRUMB' :
            return {
                ...state,
                selectedCategory: action.results || [],
            };

        case 'FETCH_CATEGORIES_LIST' :
            return {
                ...state,
                categories: action.results.categories,
                selectedCategory: action.results.parent[0] || [],
                fetchingCategoriesList: false,
                fetched: true,
            };

        case 'RESET_CATEGORIES_LIST_SEARCH' :
            return {
                ...state,
                categories: [],
            };

        case 'FETCHING_CATEGORIES_LIST_FAILED' :
            return {
                ...state,
                fetchingCategoriesList: 0,
                fetched: 0,
            };

        default:
            return state;
    }
};
